// import { INavInfo } from 'bluesteel-ui';
import { NavItem } from '../../interfaces/userContext';
import VisionText from '../../assets/VisionText.svg';
import { LEAVE_FEEDBACK, PUSH_FEEDBACK, REPORT_AN_ISSUE, REPORT_ISSUE } from '../../constants/navigation';
import { NavigateFunction } from 'react-router-dom';
import { UserProfile } from '../../interfaces/userContext';

// export const bottomList: { [key: string]: (selectedNav: any) => INavInfo } = {
//     [LEAVE_FEEDBACK]: (selectedNav) => ({
//         icon: navImage('leave_feedback'),
//         id: 100,
//         name: LEAVE_FEEDBACK,
//         onSelect: (e: any) => console.log(e),// navigatetoApolloAngular(e, selectedNav),
//         path: PUSH_FEEDBACK
//     }),
//     [REPORT_AN_ISSUE]: (selectedNav) => ({
//         icon: navImage('report_issue'),
//         id: 101,
//         name: REPORT_AN_ISSUE,
//         onSelect: (e: any) => console.log(e),// navigatetoApolloAngular(e, selectedNav),
//         path: REPORT_ISSUE
//     })
// };


export interface NavGroup {
    parent: NavItem;
    children: NavItem[];
}

export const groupNavItems = (items: NavItem[], userProfile?: UserProfile): NavGroup[] => {
    // Filter out items with order "0" - they should be hidden from navigation
    let filteredItems = items.filter(item => item.order !== "0");
    
    // For external users, remove child items for Track & Trace and redirect parent to ambient
    if (userProfile?.isExternal) {
        // Remove child items (those with _ in order) for Track & Trace
        filteredItems = filteredItems.filter(item => {
            // Remove Ambient and Grocery child items (orders like "3_1", "3_2")
            if (item.order.includes('_') && item.parent === 'Track & Trace') {
                return false;
            }
            return true;
        });
        
        // Update Track & Trace parent path to ambient
        filteredItems = filteredItems.map(item => {
            if (item.name === 'Track & Trace' && item.path !== '/track-trace/ambient') {
                return { ...item, path: '/track-trace/ambient' };
            }
            return item;
        });
    }
    
    const parentItems = filteredItems.filter(item => !item.order.includes('_'));
    const groups: NavGroup[] = parentItems.map(parent => {
        const children = filteredItems.filter(item => item.order.startsWith(`${parent.order}_`));
        return { parent, children };
    });
    return groups.sort((a, b) => a.parent.order.localeCompare(b.parent.order));
};